// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetHeaderRequest,
  TGetHeaderModel,
  IMappers,
  TGetHeaderResponse,
  IGetHeaderResponse,
  IGetHeaderResponseError,
} from './types';

export const defaultConfig: TGetHeaderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'header',
  pathApi: '/v1/get-header/',
  responseType: 'json',
} as TGetHeaderModel;

export function createGetHeaderModel(parameters: IGetHeaderRequest): TGetHeaderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetHeaderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetHeaderRequest;
}

export async function fetchGetHeader<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetHeaderOptions<TResponse200, TResponse400>): Promise<TGetHeaderResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetHeaderModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetHeaderResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetHeaderResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetHeaderResponse;
}
